import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, BookOpen, Clock3, Mail } from 'lucide-react';
import { useAuth } from '@/lib/auth';

export const SUPPORT_EMAIL = 'support@mayr-technologies.com';
export function HelpAction({ action, onClick }) {
  const { user } = useAuth();
  if (!action) return null;
  if (action.roles === 'guest' && user) return null;
  if (Array.isArray(action.roles) && user && !action.roles.some(role => user.roles?.includes(role))) {
    return <p className="help-action-note">This action requires a {action.roles.includes('client') ? 'client' : action.roles.length === 1 ? 'lead technician' : 'contractor'} account with the relevant access.</p>;
  }
  const needsSignIn = !user && action.to.startsWith('/app');
  return <Link className="help-text-link" to={needsSignIn ? '/signin' : action.to} onClick={onClick}>
    {needsSignIn ? `Sign in to continue` : action.label}<ArrowRight size={16} aria-hidden="true" />
  </Link>;
}
export function GuideCard({ guide, compact = false, onClick }) {
  return <Link to={`/help/${guide.id}`} className={`help-guide-card ${compact ? 'compact' : ''}`} onClick={onClick}>
    <div className="help-guide-meta"><span>{guide.category}</span><span><Clock3 size={13} aria-hidden="true" />{guide.minutes} min</span></div>
    <h3>{guide.title}</h3>
    {!compact && <p>{guide.summary}</p>}
    <span className="help-card-bottom">Read the guide <ArrowRight size={16} aria-hidden="true" /></span>
  </Link>;
}
export function HelpSupport({ page, onClick }) {
  return <aside className="help-support">
    <span className="help-icon-tile"><Mail size={21} aria-hidden="true" /></span>
    <div><h2>Need a person to help?</h2><p>Send our support team the details. We can help you find the next step.</p>
      <Link to={`/help/contact${page ? `?page=${encodeURIComponent(page)}` : ''}`} className="help-text-link" onClick={onClick}>Contact support <ArrowRight size={16} aria-hidden="true" /></Link>
      <a className="help-support-email" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
    </div>
  </aside>;
}
export function HelpBreadcrumb({ title }) {
  return <nav aria-label="Help breadcrumb" className="help-breadcrumb"><Link to="/help"><BookOpen size={15} aria-hidden="true" />Help center</Link><span aria-hidden="true">/</span><span>{title}</span></nav>;
}
